import styled from 'styled-components'

export const PEOPLE_TABLE_GRID = 'minmax(0, 1fr) 130px 140px 44px'
export const PEOPLE_TABLE_GRID_SM = 'minmax(0, 1fr) 140px 44px'

export const PeopleTableGrid = styled.div`
  display: grid;
  grid-template-columns: ${PEOPLE_TABLE_GRID};
  gap: ${({ theme }) => theme.spacing.lg}rem;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.sm}rem ${({ theme }) => theme.spacing.lg}rem;
  min-width: 0;
  width: 100%;

  > * {
    min-width: 0;
  }

  /* Hide role at lg so the 3-column layout kicks in on narrower viewports.
     minmax(0, 1fr) + cell overflow prevent PERSON/ROLE overlap when the
     settings content pane is narrower than the viewport (DoubleColumnLayout). */
  @media (max-width: ${({ theme }) => theme.breakpoint.lg}) {
    grid-template-columns: ${PEOPLE_TABLE_GRID_SM};

    .col-role {
      display: none;
    }
  }
`

export const PeopleTableHeaderRow = styled(PeopleTableGrid)`
  background: ${({ theme }) => theme.colors.neutralGray};
  border-top: 1px solid ${({ theme }) => theme.colors.neutralGray};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralGray};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.iconGray};
  padding-top: ${({ theme }) => theme.spacing.xs}rem;
  padding-bottom: ${({ theme }) => theme.spacing.xs}rem;
`

export const PeopleTableDataRow = styled(PeopleTableGrid)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralGray};
  position: relative;

  &:hover {
    background: ${({ theme }) => theme.colors.defaultHover};
  }
`

export const PersonCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  min-width: 0;
  overflow: hidden;
`

export const StatusCell = styled.div<{ $tone?: 'member' | 'invited' }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  min-width: 0;
  color: ${({ theme, $tone }) =>
    $tone === 'member'
      ? theme.colors.success
      : $tone === 'invited'
      ? theme.colors.warning
      : 'inherit'};
`

export const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
`
